import classNames from 'classnames';
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { MultiTabPanelHeaderProps } from './panels.props';
import * as TagNames from './panels.tagnames';

@customElement(TagNames.MultiTabHeader)
export class AtlMultiTabPanelHeader
   extends LitElement
   implements MultiTabPanelHeaderProps
{
   declare headerClassName: string;

   static properties = {
      headerClassName: { type: String },
   };

   constructor() {
      super();
      this.headerClassName = '';
   }

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      return html`
         <div class="atl-wc-multitab-panel">
            <div class=${classNames('card-header', this.headerClassName)}>
               <ul
                  class=${classNames(
                     'flex-nowrap nav nav-tabs',
                     this.headerClassName
                  )}
                  role="tablist"
                  aria-label="tablist"
               >
                  <slot></slot>
               </ul>
            </div>
         </div>
      `;
   }
}
